import React, {FC} from 'react';

import {PartialLocation} from '..';

import Items from './Items';
import Notes from './Notes';

import * as styles from './styles.module.scss';

type DetailsProps = {
	location: PartialLocation
	isPrivate?: boolean
};

const Details: FC<DetailsProps> = ({location, isPrivate}) => (
	<div className={styles.wrapper}>
		<h1 className={styles.title}>
			{location.details.name}
		</h1>
		<Items
			location={location}
			isPrivate={isPrivate}
		/>

		{/* By checking ID, we skip rendering during SSR */}
		{location.details.id && (
			<Notes notes={location.details.notes} />
		)}
	</div>
);

export default Details;
